export function formErrorFocusInitializerFactory(doc: Document): () => void {
	return (): void => {
		doc.addEventListener('submit', submitEvent => {
			const firstInputWithError: HTMLInputElement = (submitEvent.target as HTMLFormElement).querySelector(
				'input.ng-invalid'
			);
			if (firstInputWithError) {
				firstInputWithError.focus();
			}
		});
	};
}
